// The MIT License (MIT)
//
// Copyright (c) 2018 Akveo.
//
//     Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
//     The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
//     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
//     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
//     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import ArrowBack from './arrow-back';
import ArrowUp from './arrow-up';
import Award from './award';
import Bell from './bell';
import Calendar from './calendar';
import Check from './checkmark';
import CheckCircle from './checkCircle';
import ChevronDown from './chevron-down';
import ChevronLeft from './chevron-left';
import ChevronRight from './chevron-right';
import CircleFill from './circle-fill';
import Clock from './clock';
import Cross from './cross';
import CrossCircle from './crossCircle';
import Document from './document';
import Download from './download';
import Edit from './edit';
import Email from './email';
import EyeOff from './eyeOff';
import EyeOn from './eyeOn';
import Folder from './folder';
import Globe from './globe';
import Grid from './grid';
import Hash from './hash';
import Home from './home';
import Info from './info';
import Loader from './loader';
import Lock from './lock';
import Menu from './menu';
import Minus from './minus';
import Moon from './moon';
import More from './more';
import Note from './note';
import Palette from './palette';
import Person from './person';
import PersonAddIcon from './person-add';
import Phone from './phone';
import Pin from './pin';
import Plus from './plus';
import PlusCircle from './plus-circle';
import Power from './power';
import QuestionCircle from './questionCircle';
import RadioOff from './radio-off';
import RadioOn from './radio-on';
import RefreshIcon from './refresh';
import Search from './search';
import Settings from './settings';
import Share from './share';
import SkipBack from './skip-back';
import Square from './square';
import Star from './star';
import StarFilled from './star-filled';
import Sun from './sun';
import Sync from './sync';
import Tag from './tag';
import Task from './task';
import Text from './text';
import Trash from './trash';

export const EvaIcons = {
  ArrowUp,
  CheckCircle,
  CrossCircle,
  QuestionCircle,
  Globe,
  Award,
  Bell,
  Phone,
  Edit,
  SkipBack,
  Square,
  CircleFill,
  Document,
  Tag,
  Home,
  EyeOff,
  EyeOn,
  Clock,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Text,
  PlusCircle,
  ArrowBack,
  Calendar,
  Loader,
  Check,
  Cross,
  Grid,
  Menu,
  More,
  Hash,
  Note,
  Search,
  Settings,
  StarFilled,
  Star,
  Task,
  Trash,
  Person,
  PersonAddIcon,
  Palette,
  Email,
  Info,
  Folder,
  Download,
  Minus,
  Moon,
  Pin,
  Plus,
  Power,
  Refresh: RefreshIcon,
  Sync,
  Share,
  Sun,
  Lock,
  RadioOn,
  RadioOff,
};
